export const blockIconsNavigationArrowBack = (
	<span className='material-symbols-outlined'>arrow_back</span>
);
